export default __webpack_public_path__ + "static/banner-mobile-f888c154671599fd2ed587b146827bca.svg";